import type { TLatLng } from './types';

export function calculatePolygonCenter(points: TLatLng[]): TLatLng {
  const latSum = points.reduce((sum, [lat]) => sum + lat, 0);
  const lngSum = points.reduce((sum, [, lng]) => sum + lng, 0);
  return [latSum / points.length, lngSum / points.length];
}
